import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=2b22f4b2&"
import script from "./CallUs.vue?vue&type=script&lang=js&"
export * from "./CallUs.vue?vue&type=script&lang=js&"
import style0 from "./CallUs.vue?vue&type=style&index=0&id=2b22f4b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports